import type { WebModule } from '../core/index.js'
import type { ScheduleAdminApi } from './adminApi.js'
import { ShiftPreferencesPanel } from './components/ShiftPreferencesPanel.js'
import { SCHEDULE_HELP_TOPICS } from './help.js'

/** The Preferences tab's id, for a caller that opens a roster row straight onto it. */
export const PREFERENCES_TAB = 'preferences'

/** What the schedule module contributes to the shells: an open roster row's Preferences tab, the worker's shift preferences for next month as staff read them. */
export const scheduleWebModule: WebModule<ScheduleAdminApi> = {
  name: 'schedule',
  rosterRowTabs: [{ key: PREFERENCES_TAB, label: 'Preferences', panel: ({ workerId }) => <ShiftPreferencesPanel workerId={workerId} /> }],
  helpTopics: SCHEDULE_HELP_TOPICS,
}
